

export class FilterTruckingShipmentPackageDto {

	public idReserca: string;
	
    public filterKeys: String[];

	public searchText: string;
	
	public sliceCount: number = 100;

	public static buildPage(searchtext: string, activeFilterKeys: Array<string>): FilterTruckingShipmentPackageDto {
		let result = new FilterTruckingShipmentPackageDto();
		result.searchText = searchtext;
		result.filterKeys = activeFilterKeys;
		return result;
	}
}
